import SearchResultsPageContentType from '@js/content-types/search-results-page-content-type.es6.js';

export default class SearchResultService {
  constructor() {

  }

  getNodeLink(result) {
    const titleOnPage = result['field_title'];
    const locationName = result['field_location_name'];
    if (locationName && locationName.length > 0) {
      return locationName;
    } else if (titleOnPage && titleOnPage.length > 0) {
      return titleOnPage;
    }
    return result.title;
  }

  getResultType(result) {
    const searchResultsPage = new SearchResultsPageContentType();

    switch (result.type) {
      case 'Conditions/Services/Treatments Page':
        return result['field_category'];
      case 'Location':
      case 'Super Location Parent':
      case 'Super Location Child':
        return searchResultsPage.locationFilterLabel.item.$(0).text();
      case 'Leadership Bio':
        return searchResultsPage.leadershipFilterLabel.item.$(0).text();
      case 'Research':
        return searchResultsPage.researchFilterLabel.item.$(0).text();
      case 'Super Specialty Parent':
      case 'Specialty':
        return searchResultsPage.specialtyFilterLabel.item.$(0).text();
      case 'Provider':
        return searchResultsPage.providerFilterLabel.item.$(0).text();
      case 'General Page - Tier 1':
        return result['field_category'];
      case 'General Page - Tier 2':
        return result['field_category'];
      case 'General Page Tier 3':
        return searchResultsPage.blogFilterLabel.item.$(0).text();
      default:
        return '';
    }
  }

  getResultBody(result) {
    const bodyMaxLength = 203;
    switch (result.type) {
      case 'Research':
        const researchBody = `${result['field_additional_notes']} ${result['field_conference_name']} ${result['field_conference_date']} ${result['field_conference_location']} ${result['field_name_of_publication']} ${result['field_volume_of_publication']} ${result['field_date_of_publication']}`
        return this.trimStringToLength(researchBody, bodyMaxLength);
      case 'Super Specialty Parent':
        if (result['field_specialty_overview'].length > 0) {
          return this.trimStringToLength(result['field_specialty_overview'], bodyMaxLength);
        }
        return result['field_hero_banner_text'];
      case 'Specialty':
        return this.trimStringToLength(result['field_specialty_overview'], bodyMaxLength);
      case 'Leadership Bio':
        return this.trimStringToLength(result['field_leadership_bio'], bodyMaxLength);
      case 'Location':
      case 'Super Location Parent':
      case 'Super Location Child':
        const locationBody = `${result['field_location_address']} ${result['field_about_location']}`;
        return this.trimStringToLength(locationBody);
      case 'Provider':
        const provBody = `${result['field_specialty_list']} ${result['field_care_philosophy_copy']} ${result['field_quote']} ${result['field_languages_known']} ${result['field_education_and_training']} ${result['field_certificates']} ${result['field_provider_awards']}`;
        return this.trimStringToLength(provBody, bodyMaxLength);
      case 'Conditions/Services/Treatments Page':
        return this.trimStringToLength(result['field_overview'], bodyMaxLength);
      case 'General Page - Tier 1':
        return this.trimStringToLength(result['field_formatted_text_section_g1'], bodyMaxLength)
      case 'General Page - Tier 2':
        return this.trimStringToLength(`${result['field_g2_formatted_text_summary']} ${result['field_g2_formatted_text_section']}`, bodyMaxLength);
      case 'General Page Tier 3':
        return this.trimStringToLength(result['field_g3_formatted_text'], bodyMaxLength);
      default:
        return '';
    }
  }

  trimStringToLength(string, length) {
    return string.length > length ? string.substring(0, length) + "..." : string;
  }
}
